module.exports = __webpack_public_path__ + "img/white-frdarw.882e1509.svg";